import Swiper from 'swiper'

export default function index(){
  const swiperParams = {
    slidesPerView: 3,
    spaceBetween: 50,
  }
  const swiper = new Swiper('.swiper', swiperParams)
}